<template>
	<BaseCmsPage v-slot="{page}">
	<Body class="auth-lr auth-r" />
		<AuthLoginRegisterLayout>
			<template #col1>
				<h1 style="display: none;" v-if="page?.seo_h1">{{ page?.seo_h1 }}</h1>
				<BaseCmsLabel tag="h2" class="login-title" code="signup" />

				<AuthSocialLogin mode="signup" />

				<BaseAuthSignupForm class="form-signup form-animated-label" v-slot="{fields, errors, apiErrors, status, contentType, loading}" @load="onFormLoad">
					<!-- <template v-if="contentType != 'confirmSignup'">
						<h2 class="a-subtitle a-signup-login"><BaseCmsLabel code="login_information" /></h2>
						<div class="a-subtitle2"><BaseCmsLabel code="login_information_subtitle" /></div>
					</template> -->
					<BaseAuthConfirmSignup v-if="contentType == 'confirmSignup'" v-slot="{status}" redirect="auth_login" :redirect-timeout="3000">
						<BaseCmsLabel :code="status.label_name" />
					</BaseAuthConfirmSignup>
					<div v-else class="form-wrapper">
						<template v-if="!status?.success">
							<template v-if="apiErrors?.length">
								<div class="global-error" v-for="apiError in apiErrors" :key="apiError">{{ apiError.field }}: {{ apiError.error }}</div>
							</template>
							<template v-if="Object.keys(errors)?.length">
								<BaseCmsLabel tag="div" class="global-error" code="form_validation_error" data-scroll-to-error />
							</template>
							<BaseFormField v-for="item in formFields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel, isTouched, value}">                                
								<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}]" v-interpolation>
									<template v-if="item.name == 'loyalty_request'">
										<BaseCmsLabel code="signup_loyalty_title" class="a-subtitle a-form-title-loyalty" tag="h2" />
										<BaseCmsLabel code="signup_loyalty_subtitle" class="a-form-subtitle-loyalty" tag="div" />
										<span v-for="(option, index) in item.options" :key="index" :class="['field-loyalty', 'field-loyalty_request', 'field-loyalty_request-'+option.key]">											
											<BaseFormInput mode="custom" :name="item.name" :checked="option.selected" :id="'field-loyalty_request-'+option.key" :value="option.key" />
											<label :for="'field-loyalty_request-'+option.key">{{option.title}}</label>
											
											<span class="note">
												<BaseCmsLabel :code="item.name+'_'+option.key+'_note'" default="" />
												<template v-if="option.key == 'e'">
													<BaseFormField v-if="loyaltyCodeField" :item="loyaltyCodeField" v-slot="{errorMessage}">													
														<BaseFormInput :id="loyaltyCodeField.name" class="field_string" :maxlength="loyaltyCodeField.maxLength" :size="loyaltyCodeField.maxLength" :placeholder="labels.get('loyalty_code')" />
														<span class="error" v-show="errorMessage" v-html="errorMessage" />
													</BaseFormField>
												</template>
											</span>
										</span>
									</template>
									<BaseFormInput v-else :id="'signup-'+item.name" />
									<BaseCmsLabel v-if="item.name != 'loyalty_request'" tag="label" :for="'signup-'+item.name" :code="item.name" />
									<span class="error" v-show="errorMessage" v-html="errorMessage" />
								</p>
							</BaseFormField>
							<button class="btn btn-primary btn-signup" type="submit" :class="{'loading': loading}"><UiLoader v-if="loading" /><span><BaseCmsLabel code="signup_btn_title" /></span></button>
						</template>
						<div v-else>
							<BaseCmsLabel tag="div" class="global-success" :code="status.data.label_name" />
						</div>
					</div>
				</BaseAuthSignupForm>
			</template>
			<template #col2>
				<div v-if="page?.content" class="cms-content" v-html="page?.content" v-interpolation></div>
				<div class="lr-btn-pw">
					<BaseAuthUser v-slot="{urls}">
						<NuxtLink :to="urls.auth_login" class="btn btn-primary"><span>Prijavite se</span></NuxtLink>
					
						<p class="auth-links">				                         
							<NuxtLink :to="urls.auth_forgotten_password" class="forgotten"><div v-html="labels.get('forgotten_password')"></div></NuxtLink>
						</p>                        
					</BaseAuthUser>
				</div>
			</template>
		</AuthLoginRegisterLayout>
	</BaseCmsPage>
</template>

<script setup>
	const {getAppUrl} = useApiRoutes();
	const labels = useLabels();
	
	const formFields = ref([]);
	const loyaltyCodeField = ref(null);

	function onFormLoad({fields}) {
		fields.forEach(field => {
			if(field.name == 'loyalty_request') {
				let newfield = field;
				newfield.type = 'radio';
				newfield.value = '';
				newfield.options = [
					{
						"title": "Nemam karticu, želim novu",
						"key": "n",
						"code": null,
						"selected": true
					},
					{
						"title": "Imam karticu",
						"key": "e",
						"code": null,
						"selected": false
					},
					{
						"title": "Zasad ne želim karticu",
						"key": "",
						"code": null,
						"selected": false
					}
				]
				formFields.value.push(newfield);
			}
			else if(field.name == 'loyalty_code') {
				loyaltyCodeField.value = field;
			
				const maxLengthItem = field.validation?.find(item => item.type === 'max_length');
				loyaltyCodeField.value.maxLength = maxLengthItem?.value ? maxLengthItem?.value : 45;				
			} else {
				formFields.value.push(field);
			}
		})
	}
</script>

<style lang="less" scoped>
	.form-wrapper{display: flex; flex-flow: column;}
	.field-first_name{order: 1;}
	.field-last_name{order: 2;}
	.field-email{order: 3;}
	.field-password{order: 4;}
	.field-password_confirm{order: 5;}
	.field-loyalty_request{order: 6;}
	.field-newsletter{order: 7;}
	.field-accept_terms{order: 8;}
	.btn-signup{order: 9;}


	p.field-loyalty_request{
		border: 1px solid var(--primaryColor); border-radius: 2px; padding: 18px 24px 23px; margin: 14px 0 24px;
		@media (max-width: @t){padding: 15px; margin: 10px 0 15px;}
		@media (max-width: @m){margin: 6px 0 19px;}
	}
	.a-form-title-loyalty{
		line-height: 32px; padding: 0 0 1px; margin: 0;
		&:after{background: url(assets/images/loyalty-kartice.svg) top left no-repeat;background-size: contain; width: 87px; height: 53px; position: absolute; content: ""; right: 0px; top: 0px;}
		@media (max-width: @t){
			&:after{width: 77px; height: 46px;}
		}
		@media (max-width: @m){
			font-size: 18px; line-height: 24px;
			&:after{width: 63px; height: 38px;}
		}
	}
	.a-form-subtitle-loyalty{
		font-size: 18px; line-height: 24px; padding-bottom: 5px;
		@media (max-width: @t){font-size: 16px;}
	}
	.field-loyalty_request > span{
		input[type=radio] + label{
			font-size: 18px; font-weight: bold;
			&:before{width: 22px; height: 22px;}
		}
		@media (max-width: @t){
			input[type=radio] + label{
				&:before{width: 20px; height: 20px;}
			}
		}
		@media (max-width: @m){
			input[type=radio] + label{font-size: 16px!important; padding-top: 3px;}
		}
	}
</style>
